import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { sourceInterceptor } from '@/interceptors/source.interceptor';
import { tokenInterceptor } from '@/interceptors/token.interceptor';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { routes } from './app.routes';

registerLocaleData(localeNl);

ModuleRegistry.registerModules([AllCommunityModule]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAngularSvgIcon(),
    provideFlatpickrDefaults({}),
    provideHttpClient(withInterceptors([tokenInterceptor, sourceInterceptor])),
    provideAnimations(),
    provideTranslateService({
      defaultLanguage: 'en',
    }),
    { provide: LOCALE_ID, useValue: 'nl' },
  ],
};
